import Axios  from "axios"

export const getCrops = () => async (dispatch) => {
    dispatch({
        type: 'CROP_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/crop/getall/', {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )      
        if(status===200){            
            dispatch({
                type: 'CROPS_GET_SUCCESS',
                payload: data.crops
            }) 
        }

    } catch (error) {
        dispatch({
            type: 'CROP_ERROR'           
        })         
    }
}

export const getCropDetail = (crop) => async (dispatch) => {
    dispatch({
        type: 'CROP_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/crop/get/'+ crop, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )            
        if(status===200){            
            dispatch({
                type: 'CROP_GET_DETAIL_SUCCESS',
                payload: data.crop
            })             
        }

    } catch (error) {
        dispatch({
            type: 'CROP_ERROR'           
        })         
    }
}

export const getCropsByPlot = (plot) => async (dispatch) => {
    dispatch({
        type: 'CROP_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/crop/getbyplot/'+ plot, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if(status===200){
            dispatch({
                type: 'CROPS_BY_PLOT_SUCCESS',
                payload: data.crops
            })             
        }

    } catch (error) {
        dispatch({
            type: 'CROP_ERROR'           
        })         
    }
}

export const addCrop = (name, description) => async (dispatch) => {
    dispatch({
        type: 'CROP_LOADING'
    })
    try {
        const {
            data,
            status
        } = await Axios.post(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/crop/register', {
                name: name,
                description: description
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            let newCrop = {
                _id: data.id,
                name: name,
                description: description
            }
            dispatch({
                type: 'CROP_ADD_SUCCESS',
                payload: newCrop
            })
        }
    } catch (error) {
        dispatch({
            type: 'CROP_FAIL'
        })
    }
}

export const editCrop = (name, description, idCrop) => async (dispatch) => {
    dispatch({
        type: 'CROP_LOADING'
    })
    try {
        await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/crop/edit/' + idCrop, {
                name: name,
                description: description
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'CROP_EDIT_SUCCESS',
            payload: {
                name: name,
                description: description,
                _id: idCrop
            }
        })
    } catch (error) {
        dispatch({
            type: 'CROP_ERROR'
        })
    }
}

export const removeCrop = (idCrop) => async (dispatch) => {
    try {
        const {
            data,
            status
        } = await Axios.delete(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/crop/remove/' + idCrop, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CROP_DELETE_SUCCESS',
                payload: {
                    idCrop: idCrop,
                    message: data.message,
                    count: data.count
                }
            })
        }else{
            dispatch({
                type: 'CROP_DELETE_NOT_SUCCESS',
                payload: {
                    message: data.message,
                    count: data.count
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'CROP_ERROR'
        })
    }
}